import React, { useState, useRef, useEffect } from "react";
import { HexColorPicker } from "react-colorful";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText"; // Add color text icon from MUI
import { useCard } from "context/CardContext";

const ColorPicker = ({ color, setColor, showPicker, setShowPicker }) => {
  const { getPickerPosition } = useCard();
  const pickerRef = useRef(null);
  const [position, setPosition] = useState({ top: 40, left: 0 });

  // Function to adjust position dynamically
  const updatePosition = () => {
    setPosition(getPickerPosition(pickerRef, "tool-icon-text-color"));
  };

  useEffect(() => {
    if (showPicker.isShow) {
      setTimeout(updatePosition, 50); // Ensure picker is rendered before positioning
    } else {
      pickerRef.current = null; // Reset pickerRef when picker is closed
    }

    const handleResize = () => {
      if (pickerRef.current) {
        updatePosition(); // Only call if picker exists
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPicker?.isShow]);

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        marginTop: "4px",
      }}
    >
      {/* Color Fill Icon - Click to toggle color picker */}
      <FormatColorTextIcon
        id="tool-icon-text-color"
        className="toolbar-icon tool-icon"
        onClick={() => {
          setShowPicker({
            isShow: showPicker.type === "color" ? !showPicker.isShow : true,
            type: "color",
          });
        }} // Toggle visibility on click
        style={{
          color: `${color}`,
          fontSize: "30px",
        }}
      />

      {/* Color Picker - Show only when `showPicker` is true */}
      {showPicker.type === "color" && showPicker.isShow && (
        <div
          ref={pickerRef}
          className="color-picker-container tool-icon"
          style={{
            position: "absolute",
            top: `${position.top}px`,
            left: `${position.left}px`,
            background: "#fff",
            padding: "8px",
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
            borderRadius: "5px",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column", // Stack items vertically
            alignItems: "center",
          }}
        >
          <HexColorPicker color={color} onChange={setColor} />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
